import { useSsoRedirectStore } from 'src/store/sso-redirect';

import { AuthHandoffScreen } from './AuthHandoffScreen';

export function SsoRedirectOverlay() {
  const isRedirecting = useSsoRedirectStore((state) => state.isRedirecting);
  const message = useSsoRedirectStore((state) => state.message);

  if (!isRedirecting) return null;

  return <AuthHandoffScreen message={message} />;
}
